import React, { memo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import arrow from 'images/three_d_studio/remesh/arrow.webp'
import remeshAfter from 'images/three_d_studio/remesh/remesh_after.webp'
import remeshBefore from 'images/three_d_studio/remesh/remesh_before.webp'

function ExampleSection() {
  const t = useTranslation()

  return (
    <div className="example-section">
      <div className="example-section__model">
        <div className="example-section__model-item">
          <span className="example-section__model-item-title cgt-caption-semibold">
            {t('viewerSidebar.enhance.remesh.example.highPoly')}
          </span>
          <img
            className="example-section__remesh-image"
            src={remeshBefore}
            alt="High-poly Mesh"
            width={112}
            height={112}
          />
        </div>
        <img
          className="example-section__model-arrow"
          src={arrow}
          alt="Arrow"
          width={27}
          height={12}
        />
        <div className="example-section__model-item">
          <span className="example-section__model-item-title cgt-caption-semibold">
            {t('viewerSidebar.enhance.remesh.example.optimized')}
          </span>
          <img
            className="example-section__remesh-image"
            src={remeshAfter}
            alt="Optimized Mesh"
            width={112}
            height={112}
          />
        </div>
      </div>
    </div>
  )
}

export default memo(ExampleSection)
